import { useMemo } from 'react';
import { useMetadata } from '../contexts/MetadataProvider';
import { computeRank } from '../utils/rank';

export function useRank() {
  const { countsBySrs } = useMetadata();
  return useMemo(() => computeRank(countsBySrs), [countsBySrs]);
}